<div class = "modal-content2">
    <div class="modal-header">
        <h5 class="modal-title">Filtrar</h5>
        <button class="close" data-dismiss="modal" aria-label="Close"
            (click)="onNo()">
            <fa-icon [icon]="faClose"></fa-icon>
        </button>
    </div>
    
    <div class="modal-body">
        <div class="order-option-list">
            <div class="order-option">
                <div>
                    <input type="radio" name="sortOption" [(ngModel)]="selectedSortOption" value="1">
                </div>
                <div>
                    <span>A-Z</span>
                </div>
            </div>
            <div class="order-option">
                <div>
                    <input type="radio" name="sortOption" [(ngModel)]="selectedSortOption" value="2">
                </div>
                <div>
                    <span>Z-A</span>
                </div>
            </div>
            <div class="order-option">
                <div>
                    <input type="radio" name="sortOption" [(ngModel)]="selectedSortOption" value="3">
                </div>
                <div>
                    <span>Menor a mayor precio</span>
                </div>
            </div>
            <div class="order-option">
                <div>
                    <input type="radio" name="sortOption" [(ngModel)]="selectedSortOption" value="4">
                </div>
                <div>
                    <span>Mayor a menor precio</span>
                </div>
            </div>
        </div>

        <div class = "actions-container">
            <span class = "filter-button" (click)="onButtonClick()">Filtrar</span>
            <span class = "clean-filters" (click)="cleanFilters()">Limpiar filtros</span>
        </div>
    </div>
</div>

